import axios from 'axios';
const instance = axios.create({baseURL: 'https://api.rv.mylotspy.com/api/v1'});
export default instance;
